





















import {Component, Prop, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';

const alerts = namespace('alerts')

@Component({
  name: "SnackBar"
})
export default class SnackBar extends Vue {
  @Prop({type: [Boolean], default: false}) protected top!: boolean
  @Prop({type: [Boolean], default: false}) protected bottom!: boolean
  @Prop({type: [Boolean], default: false}) protected left!: boolean
  @Prop({type: [Boolean], default: false}) protected right!: boolean
  @Prop({type: [Boolean], default: false}) protected centered!: boolean
  @Prop({type: [Boolean], default: false}) protected show!: boolean
  @Prop({type: [String], default: '#494949'}) protected color!: string
  @Prop({type: [String], default: ''}) protected contentClass!: string
  @Prop({type: [String], default: '#fff'}) protected textColor!: string
  @Prop({type: [String], default: '16px'}) protected fontSize!: string
  @Prop({type: [Array], default: () => []}) protected messages!: string[]
  @Prop({type: [Number], default: 4000}) protected time!: string[]
}
